import React, { Fragment } from 'react';
import {useNavigate } from 'react-router-dom'
import styles from './challan-detailed.module.css';

const ChallanPaid = () => {
    const navigate = useNavigate()
    const redirectPath = () => {
        const sessionDetails = JSON.parse(sessionStorage.getItem('eChallanToken'))
        const token = sessionDetails?.token || ""
        navigate(`/challan-detailed/${token}`)
    }

    return (
        <Fragment>
            <div className={styles['challan-paid-container']}>
                <div className={styles['challan-paid-card']}>
                    <img src='../images/challan-detailed/challan-paid.svg' alt="challan-paid" />
                    <h2>Challan paid successfully!</h2>
                    <p>For queries contact: <span>challan@invincibleocean.com</span></p>
                </div>
                <br />
                <div>
                    <button className="btn btn-primary" onClick={() =>redirectPath()} >Pay more challans</button>
                </div>

            </div>
        </Fragment>
    )
};

export default ChallanPaid;
